export const STORAGE_KEY = "twk_a11y_prefs";

export const DEFAULT_PREFS = {
  largerText: false,
  higherContrast: false,
  reduceMotion: false,
  underlineLinks: false,
};

const CLASS_MAP = {
  largerText: "a11y-larger-text",
  higherContrast: "a11y-high-contrast",
  reduceMotion: "a11y-reduce-motion",
  underlineLinks: "a11y-underline-links",
};

export const REDUCE_MOTION_CLASS = CLASS_MAP.reduceMotion;
export const PREFS_CHANGED_EVENT = "twk-a11y-prefs-changed";

export function readStoredPrefs() {
  if (typeof window === "undefined") return { ...DEFAULT_PREFS };
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return { ...DEFAULT_PREFS };
    const parsed = JSON.parse(raw);
    return { ...DEFAULT_PREFS, ...parsed };
  } catch (error) {
    return { ...DEFAULT_PREFS };
  }
}

export function applyPrefsToDocument(prefs) {
  if (typeof document === "undefined") return;
  const root = document.documentElement;
  Object.entries(CLASS_MAP).forEach(([key, className]) => {
    root.classList.toggle(className, Boolean(prefs[key]));
  });
}

export function persistPrefs(prefs) {
  applyPrefsToDocument(prefs);
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch (error) {
    // localStorage unavailable (private browsing, quota) — preference just won't persist
  }
  if (typeof window !== "undefined" && typeof window.dispatchEvent === "function") {
    window.dispatchEvent(new CustomEvent(PREFS_CHANGED_EVENT, { detail: prefs }));
  }
}

// Combines the manual "reduce motion" preference with the OS-level
// prefers-reduced-motion media query — either one is enough to reduce motion.
export function isReducedMotionPreferred() {
  if (typeof document === "undefined") return false;
  const manual = document.documentElement.classList.contains(REDUCE_MOTION_CLASS);
  const system =
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  return manual || Boolean(system);
}
